import { createSelector } from 'reselect';

export const selectGatesSlice = state => state.gates;

export const selectGates = createSelector(
  selectGatesSlice,
  slice => slice.gates
);
export const gatesLoaded = createSelector(
  selectGatesSlice,
  slice => slice.gatesLoaded
);
export const selectActiveGate = createSelector(
  selectGatesSlice,
  slice => slice.activeGate
);

export const gatesMeta = createSelector(
  selectGatesSlice,
  slice => slice.meta
);
export const gatesFilters = createSelector(
  selectGatesSlice,
  slice => slice.filters
);
export const gatesEvent = createSelector(
  selectGatesSlice,
  slice => slice.eventId
);

export const gateCreating = createSelector(
  selectGatesSlice,
  slice => slice.isCreating
);
export const gateUpdating = createSelector(
  selectGatesSlice,
  slice => slice.isUpdating
);
export const gateDeleting = createSelector(
  selectGatesSlice,
  slice => slice.isDeleting
);
export const gatesErrors = createSelector(
  selectGatesSlice,
  slice => slice.errors
);
